import { useTranslation } from 'react-i18next';
import { usePlatform } from '@/contexts/PlatformContext';

export function usePlatformTranslation() {
  const { platform } = usePlatform();
  return useTranslation('translation', { keyPrefix: platform });
}
